import { useChipGroupContext } from './hooks/useChipGroupContext.js';

/** Component showing the number of hidden chips in a chip group. */
export const HiddenCount = () => {
  const { hiddenKeys } = useChipGroupContext();

  // oxlint-disable-next-line react/jsx-no-useless-fragment
  return <>{hiddenKeys.length}</>;
};
